import { React, useState, useEffect } from "react";
import request from "../../../../Helpers/API";
import { Modal, TextField } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import RemoveCircleIcon from "@mui/icons-material/DeleteForever";

export const EditarPaqueteModal = ({ open, onClose, id_paquete }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [paquete, setPaquete] = useState({
        nombre: "",
        periocidad: "",
        fecha: "",
        contenido: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPaquete((prev) => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        if (open && id_paquete) {
            setLoader((prev) => ({ ...prev, mostrar: true }));

            request
                .get(`DashboardPostventa/GetPaqueteEditar?id_paquete=${id_paquete}`)
                .then((result) => {
                    setLoader((prev) => ({ ...prev, mostrar: false }));
                    // console.log(result)
                    setPaquete({
                        nombre: result[0].paquete ?? "",
                        periocidad: result[0].periocidad ?? "",
                        fecha: result[0].fecha ? result[0].fecha.split("T")[0] : "",
                        contenido: result[0].contenido ?? "",
                    });
                })
                .catch((error) => {
                    setLoader((prev) => ({ ...prev, mostrar: false }));
                    console.error(error);
                    Swal.fire("Error", "No se pudo cargar el paquete", "error");
                });
        } else {
            // Reinicia el formulario cuando cierras o no hay id
            setPaquete({
                nombre: "",
                periocidad: "",
                fecha: "",
                contenido: "",
            });
        }
    }, [open, id_paquete]);


    const onGuardar = () => {
        if (paquete.nombre === undefined || paquete.nombre === null || paquete.nombre === "") {
            Swal.fire({
                title: "PAQUETE MANTENIMIENTO",
                text: "Debes introducir el nombre del paquete.",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (paquete.periocidad === undefined || paquete.periocidad === null || paquete.periocidad === "") {
            Swal.fire({
                title: "PAQUETE MANTENIMIENTO",
                text: "Debes introducir la periocidad del envio de mensajes para el paquete.",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (paquete.fecha === undefined || paquete.fecha === null || paquete.fecha === "") {
            Swal.fire({
                title: "PAQUETE MANTENIMIENTO",
                text: "Debes introducir la fecha del paquete.",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (paquete.contenido === undefined || paquete.contenido === null || paquete.contenido === "") {
            Swal.fire({
                title: "PAQUETE MANTENIMIENTO",
                text: "Debes introducir lo que incluye el paquete.",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }
        setLoader({ ...loader, mostrar: true });
        const post = {
            id_paquete: id_paquete,
            paquete: paquete.nombre,
            periocidad: paquete.periocidad,
            fecha: paquete.fecha,
            contenido: paquete.contenido,

        };
        request
            .post(`DashboardPostventa/AgregarPaqueteMantenimiento`, post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                await Swal.fire({
                    title: "PAQUETE DE MANTENIMIENTO",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                 onClose();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("PAQUETE DE MANTENIMIENTO", JSON.stringify(error), "error");
            });
    };

    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="paquetes-mantenimiento-modal-formulario">
                    <div className="paquetes-mantenimiento-modal-plantilla">
                        <div
                            className="plantilla-screen-filtro-container"
                            id="mdlFiltros-modal"
                        >
                            <PlantillaScreen
                                titulo={"EDITAR PAQUETE DE MANTENIMIENTO"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>
                                    X
                                </div>
                                <div className={`paquetes-mantenimiento-modal`}>
                                    <div className="paquetes-mantenimiento-modal-container">
                                        <TextField
                                            label="Nombre del paquete"
                                            name="nombre"
                                            value={paquete.nombre}
                                            onChange={handleChange}
                                            sx={{ mt: 2 }}
                                            fullWidth
                                        />

                                        <TextField
                                            label="Periocidad del mensaje"
                                            name="periocidad"
                                            value={paquete.periocidad}
                                            onChange={(e) => {
                                                // Permite solo números
                                                const valor = e.target.value.replace(/\D/g, "");
                                                setPaquete((prev) => ({ ...prev, periocidad: valor }));
                                            }}
                                            sx={{ mt: 2 }}
                                            fullWidth
                                            type="number"
                                        />

                                        {/* <TextField
                                            label="Fecha"
                                            type="date"
                                            name="fecha"
                                            value={paquete.fecha}
                                            onChange={handleChange}
                                            InputLabelProps={{ shrink: true }}
                                            sx={{ mt: 2 }}
                                            fullWidth
                                        /> */}

                                        <TextField
                                            label="Contenido"
                                            name="contenido"
                                            value={paquete.contenido}
                                            onChange={handleChange}
                                            multiline
                                            rows={5}
                                            sx={{ mt: 2 }}
                                            fullWidth
                                        />
                                    </div>
                                    <div className="paquetes-mantenimiento-modal-buttons">
                                        <button
                                            className="paquetes-mantenimiento-modal-button-guardar"
                                            onClick={() => onGuardar()}
                                        >
                                            Guardar
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
